import { render } from "./CustomersFeedback.vue?vue&type=template&id=0d7035d1&scoped=true&ts=true"
import script from "./CustomersFeedback.vue?vue&type=script&lang=ts"
export * from "./CustomersFeedback.vue?vue&type=script&lang=ts"

import "./CustomersFeedback.vue?vue&type=style&index=0&id=0d7035d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7035d1"]])

export default __exports__